export const RICH_TEXT_CLASSNAME = 'rich-text-editor';

export const DATA_PICKER_CLASSNAME = 'data-picker';

export const RESUME_SECTION_CLASSNAME = 'resume-section';
